@if (hasToasts()) {
  <div class="toast-stack" aria-live="polite" aria-atomic="false">
    @for (toast of toasts(); track trackById($index, toast)) {
      <div
        class="toast-card"
        [class.toast-success]="toast.type === 'success'"
        [class.toast-error]="toast.type === 'error'"
        [class.toast-warning]="toast.type === 'warning'"
        [class.toast-info]="toast.type === 'info'"
        [class.toast-loading]="toast.isLoading || toast.type === 'loading'"
        role="alert"
        (touchstart)="onTouchStart($event, toast.id)"
        (touchend)="onTouchEnd($event)"
      >
        <!-- Icon Section -->
        <span class="toast-icon">
          @if (toast.isLoading || toast.type === 'loading') {
            <span class="spinner"></span>
          } @else if (toast.type === 'success') {
            <svg viewBox="0 0 36 36" class="success-svg-icon" xmlns="http://www.w3.org/2000/svg">
              <circle cx="18" cy="18" r="16" fill="#2e7d32" />
              <path d="M11 18l5 5 10-10" stroke="white" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" fill="none" />
            </svg>
          } @else if (toast.type === 'error') {
            <svg viewBox="0 0 36 36" class="error-svg-icon" xmlns="http://www.w3.org/2000/svg">
              <circle cx="18" cy="18" r="16" fill="#c90c13" />
              <rect x="16.5" y="9" width="3" height="11" rx="1.5" fill="#FFFFFF" />
              <circle cx="18" cy="24.5" r="1.75" fill="#FFFFFF" />
            </svg>
          } @else if (toast.type === 'warning') {
            <svg viewBox="0 0 36 36" class="warning-svg-icon" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 3c1.2 0 2.2.7 2.8 1.7l13.5 23.3c.6 1.1.6 2.4 0 3.5-.6 1.1-1.8 1.8-3.1 1.8H4.8c-1.3 0-2.5-.7-3.1-1.8-.6-1.1-.6-2.4 0-3.5L15.2 4.7C15.8 3.7 16.8 3 18 3z" fill="#f59e0b" />
              <rect x="16.5" y="11" width="3" height="9" rx="1.5" fill="#FFFFFF" />
              <circle cx="18" cy="24.5" r="1.75" fill="#FFFFFF" />
            </svg>
          } @else if (toast.type === 'info') {
            <svg viewBox="0 0 36 36" class="info-svg-icon" xmlns="http://www.w3.org/2000/svg">
              <circle cx="18" cy="18" r="16" fill="#1565c0" />
              <circle cx="18" cy="11.5" r="1.75" fill="#FFFFFF" />
              <rect x="16.5" y="16" width="3" height="9" rx="1.5" fill="#FFFFFF" />
            </svg>
          } @else {
            <span class="icon-circle">
              <img [src]="getIcon(toast.type)" alt="" />
            </span>
          }
        </span>

        <!-- Message -->
        <span class="toast-message">
          @if (hasDescription(toast.message)) {
            <div class="toast-title">{{ getTitle(toast.message) | translate }}</div>
            <div class="toast-desc">{{ getDescription(toast.message) | translate }}</div>
          } @else {
            {{ toast.message | translate }}
          }
        </span>

        <!-- Action Button (optional) -->
        @if (toast.action) {
          <button
            class="toast-action"
            (click)="executeAction(toast)"
          >
            {{ toast.action.label | translate }}
          </button>
        }

        <!-- Close Button (hide for loading) -->
        @if (!toast.isLoading && toast.type !== 'loading') {
          <button
            class="toast-close"
            (click)="dismissToast(toast.id)"
            aria-label="Dismiss"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" class="close-svg-icon">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        }

        <!-- Progress Bar -->
        @if (!toast.isLoading && toast.type !== 'loading' && toast.countdown > 0) {
          <div class="toast-progress-track">
            <div
              class="toast-progress-bar"
              [style.width.%]="getProgress(toast)"
            ></div>
          </div>
        }
      </div>
    }
  </div>
}
